export const noteColors: { header: string, body: string, strong: string }[] = [
    {
        body: '#fff3cd',
        header: '#FEEA89',
        strong: '#856404'
    },
    {
        body: '#CDF2C6',
        header: '#AFECA4',
        strong: '#155724'
    },
    {
        body: '#CDE9FF',
        header: '#B7DFFF',
        strong: '#004085'
    },
    {
        body: '#FFCCE5',
        header: '#FFBBDD',
        strong: '#721c24'
    }
]